import React from 'react'

import { Input } from '@droidmap/frontend-ui'

export interface ConfirmCodeInputProps {
  confirmCode: string
  value: string
  onChange: (value: string) => void
  onValidChange?: (valid: boolean) => void
}

const ConfirmCodeInput: React.FC<ConfirmCodeInputProps> = ({
  confirmCode,
  value,
  onChange,
  onValidChange,
}) => {
  const id = React.useId()
  const isValid = value === confirmCode

  React.useEffect(() => {
    onValidChange?.(isValid)
  }, [isValid, onValidChange])

  return (
    <div className="flex flex-col">
      <label htmlFor={id} className="text-sm text-text-dim mb-2 block">
        Type <strong className="font-semibold text-text">{confirmCode}</strong>{' '}
        to confirm
      </label>
      <Input
        id={id}
        type="text"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        autoFocus
      />
    </div>
  )
}

export default ConfirmCodeInput
